module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_1-5a2b791d3bd0967f4dc359d5e2e3eba0.webp";